import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import iconHome from '../../assets/images/icons/Cinzentos/Home.svg';
import { config } from '../../common';

interface HeaderProps {
    title: string;
    subtitle?: string;
}

const Header: React.FC<HeaderProps> = (props) => {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns'])}>
                <h1 className={'header'}>{props.title}</h1>
                {props.subtitle && <p>{props.subtitle}</p>}
            </div>
            <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns'])}>
                <ul className={'tabs'} data-active-collapse="true" id="collapsing-tabs">
                    <li className={classNames(['tabs-title', 'float-right'])}>
                        <a className={'header-btn'} href={config.BaseURL}>
                            <img src={iconHome} alt={t(`common:home`)} />
                            {t(`common:home`)}
                        </a>
                    </li>

                </ul>
            </div>
        </React.Fragment>
    );
};

export default Header;
